import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGetProfile, apiValidateToken } from "services/CommonService";
import { onSignOutSuccess, setToken } from "./sessionSlice";
import { apiDashboardMenus } from "services/RoleService";

export const initialState = {
    avatar: "",
    userName: "",
    email: "",
    authority: [],
    dashboardMenus:[]
};

export const validateToken = createAsyncThunk(
    "auth/user/validateToken",
    async (params, { dispatch, rejectWithValue }) => {
        const response = await apiValidateToken();
        const data = await response.data;

        if (data?.email) {
            return data;
        }
        return rejectWithValue(null);
    }
);

export const getProfile = createAsyncThunk(
    "auth/user/getProfile",
    async (params, { dispatch, getState, rejectWithValue }) => {
        const response = await apiGetProfile();
        const data = await response.data;

        if (data?.user?.email) {
            return data.user;
        }
        dispatch(onSignOutSuccess());
        dispatch(setToken(null));
        return rejectWithValue(null);
    }
);


export const getDashboardMenus = createAsyncThunk(
    "transactions/data/getDashboardMenus",
    async (params, { rejectWithValue }) => {
        const response = await apiDashboardMenus(params);
        return response.data;
    }
);


export const userSlice = createSlice({
    name: "auth/user",
    initialState,
    reducers: {
        setUser: (_, action) => action.payload,
        // userLoggedOut: () => initialState,
    },
    extraReducers: {
        [getProfile.pending]: (state, action) => {},
        [getProfile.fulfilled]: (_, action) => action.payload,
        [getProfile.rejected]: (state, action) => {},
        [validateToken.pending]: (state, action) => {},
        [validateToken.fulfilled]: (_, action) => action.payload,
        [validateToken.rejected]: (_, action) => null,
        [getDashboardMenus.fulfilled]:(state,action)=>{state.dashboardMenus = action.payload.data}
    },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
